import "./YearFilterButtons.scss"
import {Button} from "antd";
import React from "react";
import {useUnitsState} from "../../store/UnitsState";
import {useYearFilterState} from "../../store/YearFilterState";

export function YearFilterButtons() {

  const filter = useYearFilterState()

  const units = useUnitsState()

  const currentYear = (new Date()).getFullYear()

  const yearmap: { [index: string]: string } = {
    'completed': 'Збудовані',
    'now': currentYear.toString(),
    'next': (currentYear + 1).toString(),
    'later': (currentYear + 2).toString(),
  }

  const YearButton = ({stage}: { stage: string }) => {

    const disabled = false;
    const type = filter.selected.indexOf(stage) >= 0 ? "primary" : undefined;

    return <Button disabled={disabled} type={type} onClick={() => toggleYear(stage)}>{yearmap[stage]}</Button>
  }

  function toggleYear(stage: string) {
    filter.toggle(stage)
    units.filter(filter.selected)
  }

  return <div className="YearFilterButtons">
    <YearButton stage={'completed'}/>
    <YearButton stage={'now'}/>
    <YearButton stage={'next'}/>
    <YearButton stage={'later'}/>
  </div>
}